import React from 'react';
import Suspense from "../loading/suspense"

const Login = React.lazy(() => import('./Login'));

export default function LoadableConfiguration() {

    return (
      <Suspense>
      	<Login />
      </Suspense>
    );
};